import React, { useState } from 'react'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import useOwnUser from '../../../../../../hooks/useOwnUser'
import { useUpdateVacationMutation } from '../../../../../../features/vacations/vacationsApiSlice'
import { IApprovalRejectionProps } from '../../../../../../pkg/UI'
import {
  Backdrop,
  DialogWrapper,
  DialogHeader,
  DialogContent,
  Form,
  FormGroup,
  ButtonGroup,
  CancelButton,
  RejectButton,
} from './rejectElements'

const RejectionDialog = ({ ...props }: IApprovalRejectionProps): JSX.Element => {
  const { t } = useTranslation()
  const user = useOwnUser()
  const [updateRequest] = useUpdateVacationMutation()
  const [reasoning, setReasoning] = useState<string>('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = (e: React.FormEvent): void => {
    e.preventDefault()
    setIsSubmitting(true)

    const data = { ...props.request }
    data.status = 'rejected'
    data.decision_maker_id = user.userUID as number
    data.decision_date = dayjs(new Date()).toISOString()
    data.rejection_reasoning = reasoning

    updateRequest(data)
      .then((res: any) => {
        console.log(res)
      })
      .then(() => props.refetch())
      .then(() => props.handleClose())
      .finally(() => setIsSubmitting(false))
  }

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>,
  ) => {
    setReasoning(e.target.value)
  }

  if (!props.isOpen) return <></>

  return (
    <Backdrop>
      <DialogWrapper>
        <DialogHeader>
          <h2>{t('CompanyHistory:Reject.rejectVacation')}</h2>
        </DialogHeader>
        <DialogContent>
          <Form onSubmit={handleSubmit}>
            <FormGroup>
              <label htmlFor='rejection_reasoning'>
                {t('CompanyHistory:Reject.additionalInfo')}
              </label>
              <textarea
                id='rejection_reasoning'
                name='rejection_reasoning'
                rows={4}
                value={reasoning}
                onChange={handleChange}
                placeholder={
                  t('CompanyHistory:Reject.additionalInfo') || 'Enter reason for rejection...'
                }
                required
              />
            </FormGroup>
            <ButtonGroup>
              <CancelButton
                type='button'
                onClick={props.handleClose}
                disabled={isSubmitting}
              >
                {t('CompanyHistory:Reject.cancel')}
              </CancelButton>
              <RejectButton
                type='submit'
                disabled={isSubmitting}
              >
                {isSubmitting ?
                  t('CompanyHistory:Common.processing') || 'Processing...'
                : t('CompanyHistory:Reject.reject')}
              </RejectButton>
            </ButtonGroup>
          </Form>
        </DialogContent>
      </DialogWrapper>
    </Backdrop>
  )
}

export default RejectionDialog
